import React from 'react';
import ItemList from '../components/ItemList';

function Pizzas() {

  const PizzasList = [

    { name: 'Pizza Kebab', description: 'Carne Kebab, queso, tomate y salsa', price: '8,00€', img: "https://qualitypizzafresh.com/img/cms/PIZZA-KEBAB-WEB.png" },
    { name: 'Pizza Pollo', description: 'Carne Pollo, queso, tomate y salsa', price: '8,00€', img: "https://kebabsevillaeste.com/wp-content/uploads/2020/06/pizza-pollo.jpg" },
    { name: 'Pizza Ternera', description: 'Carne Ternera, queso, tomate y salsa', price: '8,00€', img: "https://meatprotein.eu/wp-content/uploads/2021/01/img_1862-1.png" },
    { name: 'Pizza Atún', description: 'Atun, queso y tomate', price: '8,00€', img: "https://cdn.palbincdn.com/users/32899/images/pizza-atun-y-cebolla-1663067662.jpg" },
    { name: 'Pizza 4 Quesos', description: '', price: '8,00€', img: "https://www.record.com.pe/wp-content/uploads/2021/09/pizza-4-quesos-g-1.png" }
  ];


  return (
    <div id="pizzas" className="container mx-auto mt-8 px-6">
      <h2 className="text-2xl font-bold text-gray-800 mb-4">Pizzas</h2>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {PizzasList.map((menu) => (
          <ItemList
            key={menu.key}
            name={menu.name}
            description={menu.description}
            price={menu.price}
            img={menu.img}
            menuPrice={menu.menuPrice}
            menuIncludes={menu.menuIncludes}
          />
        ))}
      </div>
    </div>
  );
}

export default Pizzas;
